import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import { FormattedDateTime, FormattedMessage, FormattedReactMessage } from '../../../components/I18n';
import { getServerSyncedTime } from '../../../utils/TimeUtils';
import { useFullTrack, useTrackPendingPracticalExercises } from '../../tracks';
import { useTrackAwardProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { useUserInfo } from '../../accounts';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import I18n from 'I18n';

const ExamCongratulationsScreen = ({
  trackId
}) => {
  const {
    userInfo,
    userInfoLoading,
    userInfoError
  } = useUserInfo();
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    pendingPracticalExercises,
    pendingPracticalExercisesLoading,
    pendingPracticalExercisesError
  } = useTrackPendingPracticalExercises(trackId.toString());
  const examIsRecent = mostRecentExamAttempt ? getServerSyncedTime() - mostRecentExamAttempt.attemptFinishTime < 24 * 60 * 60 * 1000 : false;
  const probablyHasCert = track && track.certification && mostRecentExamAttempt && mostRecentExamAttempt.passed && pendingPracticalExercises && !pendingPracticalExercises.length;
  const {
    award,
    allProgressLoading,
    allProgressError
  } = useTrackAwardProgress(Number(trackId), {
    fetchPolicy: 'cache-and-network',
    polling: !!probablyHasCert && examIsRecent
  });
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsxs(Fragment, {
      children: [awardNotYetLoaded && /*#__PURE__*/_jsx(UILoadingSpinner, {
        label: I18n.text('learningCenter.exams.finished.loadingCertificate'),
        showLabel: true
      }), /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award,
        certification: track && track.certification,
        trackId: trackId,
        useCurrentText: mostRecentExamAttempt ? !mostRecentExamAttempt.passed : false
      })]
    }),
    error: trackError || mostRecentExamAttemptError || pendingPracticalExercisesError || allProgressError || userInfoError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.successHeading",
      options: {
        firstName: userInfo && userInfo.user.firstName
      }
    }),
    illustration: "trophy",
    loading: trackLoading || mostRecentExamAttemptLoading || pendingPracticalExercisesLoading || allProgressLoading || userInfoLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    showSecondaryRetakeCTA: true,
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.passedOnSubheading",
      options: {
        courseName: track && track.name,
        passDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: award ? award.awardedAt : mostRecentExamAttempt.attemptFinishTime
        })
      }
    }),
    trackId: trackId
  });
};

export default ExamCongratulationsScreen;